import { Modal as BootstrapModal } from 'react-bootstrap';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';

import 'app/components/editor/sidebar/tags/Modal/Modal.scss';

interface TagTextDeleteWarningModalProps {
  show: boolean;
  onConfirm: () => void;
  onRevert: () => void;
}

export const TagTextDeleteWarningModal = ({ show, onConfirm, onRevert }: TagTextDeleteWarningModalProps) => {
  return (
    <BootstrapModal show={show} onHide={onConfirm} contentClassName="tags-modal__content tags-modal__content--continuation" centered>
      <button onClick={onConfirm} type="button" aria-label="Close" className="tags-modal__close-btn">
        <i className="fa-solid fa-xmark" />
      </button>

      <div className="tags-modal__header">
        <i className="fa-solid fa-triangle-exclamation tags-modal__tag-icon" />

        <div className="tags-modal__title-group">
          <Typography variant="body-7" fontWeight="semibold" color="#1e2533">
            {i18n('tag.delete-text.warning.title')}
          </Typography>

          <Typography variant="body-7" fontWeight="light" color="#616066">
            {i18n('tag.delete-text.warning.message')}
          </Typography>
        </div>
      </div>

      <div className="tags-modal__actions">
        <button className="tags-modal__btn-cancel" onClick={onRevert}>
          {i18n('tag.delete-text.warning.revert')}
        </button>
        <button className="tags-modal__btn-confirm" onClick={onConfirm}>
          {i18n('tag.delete-text.warning.confirm')}
        </button>
      </div>
    </BootstrapModal>
  );
};
